import React, { useState, useEffect, useContext } from "react";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import IconSearch13 from "../assets/images/IconSearch13.png";
import IconDownYellow from "../assets/images/IconDownYellow.png";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "axios";
import { TransferContext } from "../context/TransferContext";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "40px",
  },

  marginBottomStyle: {
    marginBottom: "20px",
  },
  marginBottomStyle2: {
    marginBottom: "35px",
  },

  accordionStyle: {
    marginTop: "15px",
    "& .MuiAccordion-rounded": {
      borderRadius: "8px",
    },
    "& .MuiPaper-elevation1": {
      border: "1px solid #ddd",
      boxShadow: "none",
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  accordionDetailsStyle: {
    background: "#fff",
    margin: "0 15px 10px",
    "& p": {
      marginBottom: "25px",
    },
    "& p:last-child": {
      marginBottom: "0px",
    },

    "& .MuiAccordionDetails-root": {
      display: "block !important",
    },
  },
  textField2: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: "14px 14px 14px 2px",
    },
  },
  backgroundStyle: {
    background: "#fff",
    borderRadius: "8px",
  },
}));

const HelpCenter = () => {
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("No Question Available");
  const { removeTransfer } = useContext(TransferContext);
  const { enqueueSnackbar } = useSnackbar();

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 5; i++) {
      content.push(
        <div style={{ marginTop: "20px" }}>
          <Skeleton height="50px"></Skeleton>
        </div>
      );
    }
    return content;
  };

  const getList = async () => {
    setLoading(true);
    try {
      let response = await axios({
        url: `/api/v1/public/category`,
        method: "get",
      });
      console.log("response", response);
      setList(response.data.data);
    } catch (error) {
      console.log(error.response.data.error);
      let er = error.response.data.error;

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };
  useEffect(() => {
    removeTransfer({});
    getList();
  }, []);
  return (
    <div className={classes.root}>
      <Typography variant="h5" className={classes.marginBottomStyle}>
        Help Center
      </Typography>
      <div className={classes.marginBottomStyle2}>
        <FormControl
          fullWidth
          size="small"
          variant="outlined"
          className={classes.backgroundStyle}
        >
          <OutlinedInput
            id="outlined-adornment-amount"
            className={classes.textField2}
            startAdornment={
              <InputAdornment position="start">
                <img src={IconSearch13} alt="" />
              </InputAdornment>
            }
            placeholder="Describe your issues"
          />
        </FormControl>
      </div>
      {loading && pageLoading()}
      {!loading && list.length < 1 ? (
        <div style={{ textAlign: "center" }}>{message}</div>
      ) : null}
      {list &&
        list.map((item, i) => (
          <div className={classes.accordionStyle} key={i}>
            <Accordion>
              <AccordionSummary
                expandIcon={<img src={IconDownYellow} alt="" />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h6" style={{ color: "#009450" }}>
                  {item.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                style={{ display: "block" }}
                className={classes.accordionDetailsStyle}
              >
                {item.questions &&
                  item.questions.map((ques, index) => (
                    <div className={classes.accordionStyle} key={index}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<img src={IconDownYellow} alt="" />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography variant="h6">{ques.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{ display: "block" }}
                          className={classes.accordionDetailsStyle}
                        >
                          <Typography>{ques.answer}</Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  ))}
                {item.questions.length < 1 && (
                  <Typography variant="h6">No Question Available</Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </div>
        ))}
      {/* <div className={classes.accordionStyle}>
        <Accordion>
          <AccordionSummary
            expandIcon={<img src={IconDownYellow} alt="" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h6">Transfer Money Errors & Fixes</Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{ display: "block" }}
            className={classes.accordionDetailsStyle}
          >
            <Typography>
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas?
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div> */}
    </div>
  );
};

export default HelpCenter;
